import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import store from '../store'
import routes from './routes'
import goTo from 'vuetify/es5/services/goto'
Vue.use(VueRouter)

const scrollBehavior = () => {
    let scrollTo = 0
    return goTo(scrollTo,0)
}

global.router = new VueRouter({
    scrollBehavior,
    mode: 'history',
    routes
})

axios.interceptors.response.use(
    
    response => {

        return response;

    },
    error => {

        const {status} = error.response;

        if (status === 401) { // EXPIRA EL TOKEN

            localStorage.removeItem('token')
            localStorage.setItem('user','')
            store.commit('setLogedIn',false)
            store.dispatch('alertNotification',{
                param:{
                    title :'Error!',
                    html: error.response.data.msg,
                    timer:15000,
                    icon:'error',
                    confirmButtonColor:'#d60400'
                }
            });
            router.push('/login')

        }else if(status === 403){ // NO AUTORIZADO PARA LA ACCIÓN
            console.log(error.response)
        // store.dispatch('unAutorized')
            store.dispatch('alertNotification',{
                param:{
                    title :'Error!',
                    html: 'Su token no está autorizado para la acción',
                    timer:15000,
                    icon:'error',
                    confirmButtonColor:'#d60400'
                }
            });
            router.push('/login')

        }else if(status === 500 || status === 422){

            let response = error.response;
            store.dispatch('errorRequest',{
                data : {
                    datos: response.data.errors,
                    status : response.status,
                    response: response
                }
            });

        }

        return Promise.reject(error);
        
    }
);

store.dispatch('checkSessionStatus')

//GUARD
router.beforeEach((to, from, next) => {
    let path = to.path;
    if (path == '/') path = 'Inicio'
    document.title =  'Grupo Innofarm - '+path.replace('/','').toUpperCase().split('/')[0].split('-').join(' ');
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if(!store.state.loggedIn){
            next({path: '/login'})
        }else{
            next()
/*             if(to.path.split("/")[1] =='admin'){
                if(typeof store.state.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') === "undefined")
                     router.push('/')
                else
                    next()
            }else{
                next() 
            } */
        }
    }else{
        next()
    }
})


export default router